/* Single image */
import simg1 from '../images/service-single/1.jpg'
import simg2 from '../images/service-single/2.jpg'
import simg3 from '../images/service-single/3.jpg'
import simg4 from '../images/service-single/4.jpg'
import simg5 from '../images/service-single/5.jpg'
import simg6 from '../images/service-single/6.jpg'



const Services = [
    {
        id: 1,
        icon: 'fa-solid fa-bone',
        simage: simg1,
        title: 'Orthopedic & Performance Medicine',
        description: 'Joint pain, arthritis, and sports medicine solutions using advanced stem cell therapy and athletic performance optimization.',
        slug: 'orthopedic-performance'
    },
    {
        id: 2,
        icon: 'fa-solid fa-dna',
        simage: simg2,
        title: 'Advanced Cellular Therapies',
        description: 'Wharton\'s jelly MSCs, exosome therapies, and autologous cell concentrates with image-guided precision delivery for optimal outcomes.',
        slug: 'cellular-therapies'
    },
    {
        id: 3,
        icon: 'fa-solid fa-brain',
        simage: simg3,
        title: 'Neurological Recovery & Support',
        description: 'Post-stroke, traumatic brain injury, and neurodegenerative therapy using cutting-edge cellular regeneration protocols.',
        slug: 'neurological-recovery'
    },
    {
        id: 4,
        icon: 'fa-solid fa-vials',
        simage: simg4,
        title: 'Precision Orthobiologics',
        description: 'Enhanced PRP protocols, bone marrow aspirate concentrate (BMAC), and growth factor optimization for superior tissue regeneration.',
        slug: 'orthobiologics'
    },
    {
        id: 5,
        icon: 'fa-solid fa-person-circle-check',
        simage: simg5,
        title: 'Wellness & Regenerative Enhancement',
        description: 'Sexual wellness, anti-aging & longevity protocols, and comprehensive regenerative medicine for optimal health and vitality.',
        slug: 'wellness-enhancement'
    },
    {
        id: 6,
        icon: 'fa-solid fa-syringe',
        simage: simg6,
        title: 'Interventional Pain Procedures',
        description: 'Minimally invasive spine surgery, epidural injections, nerve blocks, and spinal cord stimulation for chronic pain management.',
        slug: 'interventional-pain'
    },
];
export default Services;